import { PostFilterBody } from '@api/api/screener';

export const hasEmptyEntityTagValues = (filters: PostFilterBody): boolean => {
  if (!filters?.entity_tag?.values) {
    return false;
  }

  const allTags = filters.entity_tag.values.flatMap(value =>
    Array.isArray(value.tags) ? value.tags : []
  );

  return allTags.length === 0;
};

export const hasUsableScreenerFilters = (filters: PostFilterBody) => {
  const hasValues = Object.values(filters).some(
    filter =>
      !!filter.values.length ||
      !!filter.exclude_values?.length ||
      !!filter.children?.length
  );

  return hasValues && !hasEmptyEntityTagValues(filters);
};
